<form [formGroup]="form" [formEditablePermission]="form">
  <div class="container-box">
    <div class="header">
      <div class="title">{{ title }}</div>
      <div class="btn-holder">
        <button
          (click)="addTaxes()"
          class="btn btn-cst-info text-uppercase"
          type="button"
          [ngClass]="primaryButtonClass"
          [disabled]="1 | isReadonlyRole"
        >
          <i class="fal fa-plus"></i> <ng-container i18n>add tax</ng-container>
        </button>
        <button
          (click)="addFees()"
          class="btn btn-cst-info text-uppercase"
          type="button"
          [ngClass]="primaryButtonClass"
          [disabled]="1 | isReadonlyRole"
        >
          <i class="fal fa-plus"></i> <ng-container i18n>add fee</ng-container>
        </button>
        <button
          (click)="onSave(form)"
          class="btn btn-success text-uppercase"
          type="button"
          [ngClass]="primaryButtonClass"
          [disabled]="1 | isReadonlyRole"
        >
          <span class="fas fa-save"></span>
          {{ saveText }}
        </button>
      </div>
    </div>

    <div class="details-box">
      <div class="box-body">
        <h6 i18n>Payment Settings</h6>

        <div class="row">
          <div class="col-sm-12">
            <mat-form-field class="mat-block">
              <textarea
                matInput
                rows="4"
                formControlName="payment_terms"
                placeholder="Payment Terms:"
                i18n-placeholder
                required
              ></textarea>
              <mat-error
                *ngIf="form.get('payment_terms').touched && form.get('payment_terms').hasError('required')"
                i18n
              >
                Payment terms are required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-12">
            <mat-form-field class="mat-block">
              <textarea
                matInput
                rows="4"
                formControlName="payment_conditions"
                placeholder="Payment Conditions:"
                i18n-placeholder
              ></textarea>
            </mat-form-field>
          </div>
        </div>

        <h6 i18n>Cancellation Policy</h6>

        <div class="radio-box">
          <mat-radio-group formControlName="cancellation_policy">
            <mat-radio-button value="Strict" i18n>
              Bookings canceled at least 60 days before the start of stay will receive 100% refund streamline
            </mat-radio-button>
            <mat-radio-button value="Firm">
              <ng-container i18n
                >Bookings canceled at least 60 days before the start of the stay will receive 100% refund</ng-container
              ><br />
              <ng-container i18n
                >Bookings canceled at least 30 days before the start of the stay will receive 50% refund</ng-container
              >
            </mat-radio-button>
            <mat-radio-button value="Moderate">
              <ng-container i18n
                >Bookings canceled at least 30 days before the start of the stay will receive 100% refund</ng-container
              ><br />
              <ng-container i18n
                >Bookings canceled at least 14 days before the start of the stay will receive 50% refund
                streamline</ng-container
              >
            </mat-radio-button>
            <mat-radio-button value="Relaxed">
              <ng-container i18n
                >Bookings canceled at least 14 days before the start of the stay will receive 100% refund</ng-container
              ><br />
              <ng-container i18n
                >Bookings canceled at least 7 days before the start of the stay will receive 50% refund</ng-container
              >
            </mat-radio-button>
            <mat-radio-button value="No Refund" i18n> No Refund </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
  </div>
</form>
